// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__dfQsH","row":"Node_row__1HwZ4","label":"Node_label__33Wr5","footer":"Node_footer__24EVI"};